export default from './SocialButtons';



// WEBPACK FOOTER //
// ./src/sharedComponents/SocialButtons/index.js